import type { Donem } from './donem';
import type { SatisKaynaklari } from './ekranKaynaklari';
import type { SaKategoriSatiri } from './ozetHesaplari';
import { useSaSorgu } from './useSatisVerisi';
import { uyariSayisi, type IadeOraniSatiri, type ZararSatiri } from './uyarilar';

/** Sekme rozeti icin. Sorgular UyarilarBlok ile AYNI anahtar: ek istek yok, Genel disinda da sayi gelir. */
export function useUyariSayisi(
  kaynaklar: SatisKaynaklari, donem: Donem, oncekiDonem: Donem, sube: string | null, kanal: string | null,
): number {
  const f = { donem, sube, kanal, onceki: oncekiDonem };
  const zarar = useSaSorgu<ZararSatiri>(kaynaklar.zararinaSatis, f);
  const kategori = useSaSorgu<SaKategoriSatiri>(kaynaklar.kategori, f);
  const iade = useSaSorgu<IadeOraniSatiri>(kaynaklar.iadeOrani, f);
  return uyariSayisi(zarar.data?.data ?? [], kategori.data?.data ?? [], iade.data?.data ?? []);
}
